import { memo } from 'react';

interface ReviewNotificationCardProps {
  reviewCount: number;
  businessStatus: boolean;
  onReviewClick: () => void;
  loading?: boolean;
}

export const ReviewNotificationCard = memo(function ReviewNotificationCard({ 
  reviewCount, 
  businessStatus,
  onReviewClick,
  loading = false 
}: ReviewNotificationCardProps) {
  if (loading) {
    return (
      <div className="bg-white rounded-lg p-4 mb-4">
        <div className="animate-pulse flex justify-between items-center">
          <div className="h-4 bg-gray-200 rounded w-32"></div>
          <div className="h-8 bg-gray-200 rounded w-20"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg p-4 mb-2">
      <div className="flex justify-between items-center">
        <button
          onClick={onReviewClick}
          className="bg-green-500 text-white px-4 py-2 rounded-lg font-medium hover:bg-green-600 transition-colors"
        >
          신규 리뷰 {reviewCount}건
        </button>
        
        <div className="flex items-center space-x-2">
          <div 
            className={`w-3 h-3 rounded-full ${
              businessStatus ? 'bg-green-500' : 'bg-gray-400'
            }`}
          />
          <span className={`text-sm font-medium ${
            businessStatus ? 'text-green-600' : 'text-gray-500'
          }`}>
            {businessStatus ? '영업중' : '영업종료'}
          </span>
        </div>
      </div>
    </div>
  );
});